// Action Types
export const SET_TENANT_DETAILS = "SET_TENANT_DETAILS";

// Action Creators
export const setTenantData = (data) => ({
  type: SET_TENANT_DETAILS,
  payload: data,
});
